import { Column, Row, IconButton } from 'components/Blocks';

import { CheckCircleIcon, MenuIcon } from 'components/Icons';

import { SidebarLinks } from './Links';
import { SideBarProjectItems } from './Projects';
import { HelpCentral } from './HelpCentral';

import { useAppWrapper } from '../WrapperContext';

import { cn } from 'styles';
import { useUser } from 'hooks';

export function SidebarContent() {
  const { isSideBarOpen, toggleSideBar, showMobileSidebar, showIconOnly } = useAppWrapper();

  const loggedUser = useUser();

  return (
    <Column
      gap={showIconOnly ? '2' : '4'}
      alignItems={showIconOnly ? 'center' : undefined}
      className={cn(
        'h-full py-4 phone:pb-0',
        showIconOnly ? 'px-2' : 'px-4',
        showMobileSidebar && isSideBarOpen && 'px-0',
      )}
    >
      {!showMobileSidebar && (
        <Row gap="2">
          {isSideBarOpen && (
            <>
              <CheckCircleIcon />

              <span className="leading-1 mx-auto font-bold">{loggedUser.team.name}</span>
            </>
          )}

          <IconButton onClick={toggleSideBar}>
            <MenuIcon />
          </IconButton>
        </Row>
      )}

      <SidebarLinks />

      <SideBarProjectItems />

      <HelpCentral />
    </Column>
  );
}
